import { createSelector } from 'reselect'
import * as R from 'ramda'
import {
  GetCheckoutAvailability,
  GetCheckoutRedirection,
  GetCheckoutSecondsWaitingTime,
  GetCheckoutStatus
} from 'store/selectors/checkout.types'

export const getCheckoutRedirection: GetCheckoutRedirection = R.prop('checkout')

export const getCheckoutAvailability: GetCheckoutAvailability = createSelector(
  getCheckoutRedirection,
  R.prop('checkoutDisabled')
)

export const getCheckoutStatus: GetCheckoutStatus = createSelector(
  getCheckoutRedirection,
  R.prop('status')
)

export const getCheckoutSecondsWaitingTime: GetCheckoutSecondsWaitingTime = createSelector(
  getCheckoutRedirection,
  R.prop('secondsWaitingTime')
)
